import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../styles/fonts";
import { CSS_COLORS } from "../../styles/styles-css-variables";

export const PDPHeadlineTypography = [
  FONTS.MinervaModern500,
  fontSize.x4,
  css`
    &:not(.color-inherit) {
      color: ${CSS_COLORS.Green};
    }

    &.color-inherit {
      color: inherit;
    }

    text-transform: uppercase;
  `,
];
